module.exports = __webpack_public_path__ + "img/Unidad21-1.52e80d25.png";